<ng-container *ngrxLet="{ activeLanguage: activeLanguage$ } as vm">
    <div class="grid header">
        <div class="main-section">
            <h1>
                {{ "dtmMainPageLib.subpage.kpo.aboutProject.title" | transloco }}
            </h1>
            <p class="message">
                {{ "dtmMainPageLib.subpage.kpo.aboutProject.description" | transloco }}
            </p>
        </div>
    </div>

    <dtm-main-page-lib-kpo-logos [activeLanguage]="vm.activeLanguage" />

    <div class="sections-container">
        <div class="grid news">
            <h2>{{ "dtmMainPageLib.subpage.kpo.news.title" | transloco }}</h2>
            <dtm-main-page-lib-kpo-news class="news-container" *ngIf="vm.activeLanguage === 'pl'">
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-09-12"
                    [previewLength]="1002"
                    newsTitle="Tu powstaną dronowe Centra Kompetencji
"
                >
                    <dtm-main-page-lib-news-14 activeLanguage="pl" />
                </ng-template>
                <ng-template dtmMainPageLibKpoNewsSlide newsDate="2025-08-27" newsTitle="Ruszył Konkurs skierowany do użytkowników KSID!">
                    <div class="standalone-news">
                        <p>
                            <strong>Dnia 27 sierpnia 2025 r.</strong> wystartowało głosowanie użytkowników systemu KSID, którego celem jest
                            dokonanie oceny Lokalizacji zgłoszonych w II etapie Konkursu, które pozytywnie przeszły weryfikację formalną.
                        </p>
                        <p>
                            Głosowanie trwa do końca dnia <strong>1 września 2025 r.</strong> i odbywa się poprzez aplikację:
                            <a href="https://ankieta-kpo.drony.gov.pl/" target="_blank" rel="noopener norefer">Ankieta KPO</a>
                        </p>
                        <p><em> (Do aplikacji należy zalogować się tymi samymi danymi, co w systemie KSID) </em></p>
                        <p>Wyniki Konkursu, w tym głosowania KSID, zostaną opublikowane do 5 września 2025 r</p>
                    </div>
                </ng-template>
                <ng-template dtmMainPageLibKpoNewsSlide newsDate="2025-08-26" newsTitle="Trwa ostania faza Konkursu!">
                    <div class="standalone-news">
                        <p>
                            Rozpoczynamy ostatnią fazę Konkursu. W ramach aktualizacji harmonogramu planujemy uruchomić
                            <strong>27 sierpnia 2025 r.</strong>
                            głosowanie użytkowników systemu KSID. Głosowanie dotyczyć będzie oceny Lokalizacji zgłoszonych w II etapie
                            Konkursu, które pozytywnie przeszły weryfikację formalną.
                        </p>
                        <p>O uruchomieniu aplikacji do głosowania poinformujemy Państwa w osobnych komunikatach.</p>
                        <p>
                            Jednocześnie informujemy, że do <strong>5 września 2025 r.</strong> planujemy zakończyć etap oceny Wniosków,
                            uwzględniając wyniki głosowania KSID oraz opublikować listę Laureatów Konkursu.
                        </p>
                    </div>
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-08-25"
                    previewLength="797"
                    newsTitle="Dzięki zaangażowaniu partnerów powstanie 10 Centrów Kompetencji w pięciu obszarach"
                    id="back-to-10-competence-centers"
                >
                    <dtm-main-page-lib-news-11 activeLanguage="pl" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-08-06"
                    previewLength="693"
                    newsTitle="KOMUNIKAT Z DNIA 6 SIERPNIA 2025 R."
                    id="announcement-08-06-2025-news"
                >
                    <dtm-main-page-lib-news-10 activeLanguage="pl" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-07-16"
                    previewLength="592"
                    newsTitle="Przed nami II Etap konkursu na stworzenie Centrów Kompetencji"
                    id="competition-results-update-news"
                >
                    <dtm-main-page-lib-news-9 activeLanguage="pl" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-06-27"
                    previewLength="660"
                    newsTitle="Wydłużenie czasu trwania Etapu II"
                    id="competition-update"
                >
                    <dtm-main-page-lib-news-8 activeLanguage="pl" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-05-21"
                    previewLength="802"
                    newsTitle="Ogłoszenie wyników I Etapu Konkursu oraz zasady kwalifikacji do Etapu II"
                    id="competition-results-news"
                >
                    <div class="standalone-news">
                        <p>
                            Z przyjemnością informujemy, że zakończyliśmy I Etap naszego Konkursu. Do kolejnego etapu zakwalifikowało się 31
                            wniosków. Na stronie internetowej konkursu opublikowaliśmy szczegółową listę laureatów, zawierającą informacje o
                            liderach, podmiotach składających wstępne wnioski oraz wielkości powierzchni poszczególnych lokalizacji.
                            Dodatkowo udostępniona została mapa prezentująca lokalizacje zakwalifikowane do Etapu II na tle zdefiniowanych w
                            konkursie obszarów geograficznych.
                        </p>

                        <p><strong>Jak wyłonimy laureatów w II Etapie?</strong></p>

                        <p>
                            W II Etapie konkursu zostanie wyłonionych łącznie 9 laureatów. Selekcja będzie przebiegać według następujących
                            zasad:
                        </p>
                        <ul>
                            <li>
                                <strong>Pierwszych pięciu laureatów</strong> stanowić będą uczestnicy, których wnioski uzyskają najwyższą
                                liczbę punktów w ramach jednego z pięciu zdefiniowanych obszarów geograficznych.
                            </li>

                            <li>
                                <strong>Kolejnych czterech laureatów</strong> wyłonionych zostanie spośród pozostałych uczestników – będą to
                                podmioty z najwyższą liczbą punktów, które nie zajęły pierwszego miejsca w swoim obszarze
                            </li>
                        </ul>

                        <p><strong>Sprawdź szczegółowe wyniki</strong></p>

                        <p>
                            Pełna lista laureatów I Etapu oraz mapa lokalizacji zakwalifikowanych do II Etapu dostępne są na stronie
                            konkursu. Zachęcamy do zapoznania się ze szczegółami:
                        </p>

                        <p><a routerLink="/nrp/results" class="link">Przejdź do wyników I Etapu</a></p>

                        <p>Gratulujemy wszystkim zakwalifikowanym i życzymy powodzenia w kolejnym etapie!</p>
                    </div>
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-05-09"
                    previewLength="792"
                    id="stage-one-winners-news"
                    newsTitle="Ponad 30 Uczestników zakwalifikowało się do Etapu II Konkursu dronowego KPO"
                >
                    <dtm-main-page-lib-news-6 activeLanguage="pl" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-05-07"
                    previewLength="799"
                    newsTitle="Konkurs KPO – kolejne zmniejszenie wymogów formalnych dla Uczestników Konkursu w Etapie&nbsp;I"
                >
                    <div class="standalone-news">
                        <p>
                            Mając na uwadze treść § 10 ust. 1 i ust. 2 regulaminu Konkursu do naboru podmiotów do współpracy przy wdrożeniu
                            usługi w ramach projektu "Rozbudowa i wyposażenie centrów kompetencji (specjalistyczne ośrodki szkoleniowe,
                            ośrodki wsparcia wdrożeń, centra monitorowania) oraz infrastruktura do zarządzania ruchem pojazdów bezzałogowych
                            jako ekosystem innowacji" (dalej: <strong>"Regulamin"</strong>), postanawia się co następuje:
                        </p>
                        <ol class="rules-list">
                            <li>
                                Regulamin ulega zmianie w ten sposób, że w Załączniku nr 4 do Regulaminu – "Kryteria oceny Wstępnych
                                Wniosków" w części 1. tabeli pkt 1a) tj. kryterium
                                <em>"Istniejące struktury przestrzeni powietrznej"</em> wprowadza się doprecyzowanie dotyczące wymogu
                                porozumienia się przez Uczestnika z podmiotem zarządzającym daną strefą ATZ. Wymóg porozumienia nie dotyczy
                                przypadku, gdy obszar Lokalizacji nie wchodzi w przestrzeń ATZ znajdującą się w odległości poziomej do 6 km
                                od lotniska, wokół którego została ustanowiona. <br />Uzasadnienie dla wprowadzenia przedmiotowej zmiany:
                                <br />
                                W opublikowanych przez PAŻP zasadach lotów w strefach geograficznych DRA-R ATZ, w odległości większej niż 6
                                km od lotniska aeroklubowego, loty BSP do wysokości 100 m AGL nie wymagają koordynacji z Zarządzającym
                                strefą ATZ.
                            </li>
                        </ol>
                    </div>
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-05-05"
                    previewLength="1000"
                    id="competition-update-news-2"
                    newsTitle="Konkurs KPO - zmniejszenie wymogów formalnych dla Uczestników Konkursu w Etapie&nbsp;I"
                >
                    <div class="standalone-news">
                        <p>
                            Wychodząc naprzeciw prośbom i wnioskom JST, mając na uwadze charakter I Etapu Konkursu*, w przypadku gdy na
                            obszarze zgłaszanej Lokalizacji znajduje się więcej niż jedna gmina, PAŻP dopuszcza złożenie wniosku w ramach I
                            Etapu wyłącznie przez jedną z gmin. Jednocześnie, wskazujemy, że gmina składająca wniosek, jest w takiej
                            sytuacji zobowiązana do złożenia oświadczenia, że działa w porozumieniu z pozostałymi gminami. Powyższe nie
                            znajduje zastosowania do wniosków składanych w ramach etapu II.
                        </p>
                        <p class="annotation">
                            *par. 6 ust. 3 pkt a) Regulaminu, stanowiący, że: "Etap 1 - służy prostej weryfikacji, czy w zaproponowanej
                            Lokalizacji możliwe jest wdrożenie Usługi, ze względu na uwarunkowania związane z przestrzenią powietrzną oraz
                            czy będzie on charakteryzował się wysoką dostępnością dla rynku dronowego – tj. pozwalał na realizację w sposób
                            płynny różnego rodzaju lotów, w tym zaawansowanych operacji BSP na szeroką skalę"
                        </p>
                    </div>
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-04-15"
                    previewLength="718"
                    id="competition-news"
                    newsTitle="Konkurs KPO - rozszerzenie zakresu możliwych do zgłoszenia Lokalizacji"
                >
                    <dtm-main-page-lib-news-3 activeLanguage="pl" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-03-19"
                    previewLength="716"
                    id="partners-news"
                    newsTitle="PAŻP szuka samorządowych partnerów do realizacji projektu dronowego w ramach KPO"
                >
                    <div class="slide-content">
                        <dtm-main-page-lib-news-2 activeLanguage="pl" />
                    </div>
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-03-10"
                    previewLength="719"
                    id="consultation-news"
                    newsTitle="Konsultacje założeń projektu KPO"
                >
                    <div class="slide-content">
                        <dtm-main-page-lib-news-1 activeLanguage="pl" />
                    </div>
                </ng-template>
            </dtm-main-page-lib-kpo-news>
            <dtm-main-page-lib-kpo-news class="news-container" *ngIf="vm.activeLanguage === 'en'">
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-09-12"
                    newsTitle="Here Is Where Drone Competence Centers Will Emerge"
                    previewLength="1000"
                >
                    <dtm-main-page-lib-news-14 activeLanguage="en" />
                </ng-template>
                <ng-template dtmMainPageLibKpoNewsSlide newsDate="2025-08-27" newsTitle="The competition for KSID users has started!">
                    <div class="standalone-news">
                        <p>
                            <strong>On August 27, 2025</strong>, the voting for KSID system users has started. Its purpose is to evaluate
                            the Locations submitted in Stage II of the Competition that have successfully passed the formal verification.
                        </p>
                        <p>
                            The voting lasts until the end of <strong>September 1, 2025</strong> and takes place via the application:
                            <a href="https://ankieta-kpo.drony.gov.pl/" target="_blank" rel="noopener norefer">KPO Survey</a>
                        </p>
                        <p><em>(You must log in to the application with the same credentials as in the KSID system)</em></p>
                        <p>The results of the Competition, including the KSID voting, will be published by September 5, 2025.</p>
                    </div>
                </ng-template>
                <ng-template dtmMainPageLibKpoNewsSlide newsDate="2025-08-26" newsTitle="The final phase of the Competition is underway!">
                    <div class="standalone-news">
                        <p>
                            We are starting the final phase of the Competition. As part of the updated schedule, we plan to launch the KSID
                            system user voting on <strong>August 27, 2025</strong>. The voting will concern the evaluation of Locations
                            submitted in Stage II of the Competition that have successfully passed the formal verification.
                        </p>
                        <p>We will inform you about the launch of the voting application in separate announcements.</p>
                        <p>
                            At the same time, we inform you that by <strong>September 5, 2025</strong>, we plan to complete the application
                            evaluation stage, taking into account the results of the KSID voting, and publish the list of Competition
                            Winners.
                        </p>
                    </div>
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-08-25"
                    previewLength="800"
                    newsTitle="Thanks to the commitment of our partners, 10 Competence Centres will be established across five thematic areas"
                    id="back-to-10-competence-centers"
                >
                    <dtm-main-page-lib-news-11 activeLanguage="en" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-08-06"
                    previewLength="693"
                    newsTitle="ANNOUNCEMENT OF 6 AUGUST 2025"
                    id="announcement-08-06-2025-news"
                >
                    <dtm-main-page-lib-news-10 activeLanguage="en" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-07-16"
                    previewLength="623"
                    newsTitle="Stage II of the competition to create Competence Centers is ahead of us"
                    id="competition-results-update-news"
                >
                    <dtm-main-page-lib-news-9 activeLanguage="en" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-06-27"
                    previewLength="661"
                    newsTitle="Extension of Stage II Duration"
                    id="competition-update"
                >
                    <dtm-main-page-lib-news-8 activeLanguage="en" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-05-21"
                    previewLength="800"
                    newsTitle="Announcement of Stage I Competition Results and Qualification Rules for Stage II"
                >
                    <div class="standalone-news">
                        <p>
                            We are pleased to announce that we have completed Stage I of our Competition. A total of 31 applications have
                            qualified for the next stage. On the competition website, we have published a detailed list of winners,
                            including information about the leaders, entities submitting preliminary applications, and the size of the areas
                            of individual locations. Additionally, a map has been made available showing the locations qualified for Stage
                            II against the defined geographical areas in the competition.
                        </p>

                        <p><strong>How will we select the winners in Stage II?</strong></p>

                        <p>
                            In Stage II of the competition, a total of 9 winners will be selected. The selection will proceed according to
                            the following rules:
                        </p>
                        <ul>
                            <li>
                                <strong>The first five winners</strong> will be participants whose applications receive the highest number
                                of points within one of the five defined geographical areas.
                            </li>

                            <li>
                                <strong>The next four winners</strong> will be selected from the remaining participants – these will be
                                entities with the highest number of points that did not take first place in their area.
                            </li>
                        </ul>

                        <p><strong>Check the detailed results</strong></p>

                        <p>
                            The full list of Stage I winners and the map of locations qualified for Stage II are available on the
                            competition website. We encourage you to review the details:
                        </p>

                        <p><a routerLink="/nrp/results" class="link">Go to Stage I results</a></p>

                        <p>Congratulations to all those who qualified, and we wish you success in the next stage!</p>
                    </div>
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-05-09"
                    previewLength="783"
                    newsTitle="Over 30 participants qualified for Stage II of the NRP drone competition"
                    id="stage-one-winners-news"
                >
                    <dtm-main-page-lib-news-6 activeLanguage="en" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-05-07"
                    previewLength="797"
                    newsTitle="NRP Competition – further reduction of formal requirements for Competition Participants in Stage&nbsp;I"
                >
                    <div class="standalone-news">
                        <p>
                            Taking into account the content of § 10 sections 1 and 2 of the Competition Regulations for the recruitment of
                            entities to cooperate in the implementation of the service under the project "Expansion and equipment of
                            competence centers (specialized training centers, implementation support centers, monitoring centers) and
                            infrastructure for the management of unmanned vehicle traffic as an innovation ecosystem" (hereinafter:
                            <strong>"Regulations"</strong>), it is decided as follows:
                        </p>
                        <ol class="rules-list">
                            <li>
                                The Regulations are amended so that in Annex No. 4 to the Regulations – "Kryteria oceny Wstępnych Wniosków"
                                ("Preliminary Application Evaluation Criteria") in part 1, table item 1a), i.e. the criterion
                                <em>"Istniejące struktury przestrzeni powietrznej"</em>
                                ("Existing airspace structures"), a clarification is introduced regarding the requirement for the
                                Participant to reach an agreement with the entity managing the given ATZ zone. The requirement for an
                                agreement does not apply if the Location area does not enter the ATZ airspace located within a horizontal
                                distance of up to 6 km from the airport around which it was established. <br />
                                Justification for this change: <br />
                                According to the rules for flights in DRA-R ATZ geographic zones published by PANSA, at a distance greater
                                than 6 km from an aeroclub airport, UAV flights up to 100 m AGL do not require coordination with the ATZ
                                zone manager.
                            </li>
                        </ol>
                    </div>
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-05-05"
                    previewLength="1000"
                    id="competition-update-news"
                    newsTitle="NRP Competition – reduction of formal requirements for Competition Participants in Stage&nbsp;I"
                >
                    <p>
                        In response to the requests and applications from local government units (JST), and taking into account the nature
                        of Stage I of the Competition*, if there is more than one municipality in the area of the reported Location, PANSA
                        allows the application in Stage I to be submitted by only one of the municipalities. At the same time, we indicate
                        that the municipality submitting the application is required, in such a situation, to submit a statement that it
                        acts in agreement with the other municipalities. The above does not apply to applications submitted in Stage II.
                    </p>
                    <p class="annotation">
                        *§ 6 section 3 point a) of the Regulations, stating that: "Stage 1 - serves for a simple verification of whether it
                        is possible to implement the Service in the proposed Location, due to conditions related to airspace, and whether it
                        will be characterized by high availability for the drone market – i.e. it will allow for the smooth execution of
                        various types of flights, including advanced UAS operations on a large scale"
                    </p>
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-04-15"
                    previewLength="810"
                    id="competition-news"
                    newsTitle="NRP Competition - extension of the scope of possible Locations to be submitted"
                >
                    <dtm-main-page-lib-news-3 activeLanguage="en" />
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-03-19"
                    previewLength="719"
                    id="partners-news"
                    newsTitle="PANSA is looking for local government partners to implement the drone project under the NRP"
                >
                    <div class="slide-content">
                        <dtm-main-page-lib-news-2 activeLanguage="en" />
                    </div>
                </ng-template>
                <ng-template
                    dtmMainPageLibKpoNewsSlide
                    newsDate="2025-03-10"
                    previewLength="672"
                    id="consultation-news"
                    newsTitle="Consultations on the assumptions of the NRP project"
                >
                    <div class="slide-content">
                        <dtm-main-page-lib-news-1 activeLanguage="en" />
                    </div>
                </ng-template>
            </dtm-main-page-lib-kpo-news>
        </div>

        <div class="grid purpose">
            <h2>{{ "dtmMainPageLib.subpage.kpo.aboutProject.purposeTitle" | transloco }}</h2>
            <ul>
                <li>
                    <img ngSrc="/assets/images/kpo/drone2.svg" alt="" height="84" width="84" />
                    <p class="title">{{ "dtmMainPageLib.subpage.kpo.aboutProject.droneMarketDevelopmentTitle" | transloco }}</p>
                    <p [innerHtml]="'dtmMainPageLib.subpage.kpo.aboutProject.droneMarketDevelopmentDescription' | transloco"></p>
                </li>
                <li>
                    <img ngSrc="/assets/images/kpo/book.svg" alt="" height="84" width="84" />
                    <p class="title">{{ "dtmMainPageLib.subpage.kpo.aboutProject.competenceCentersTitle" | transloco }}</p>
                    <p [innerHtml]="'dtmMainPageLib.subpage.kpo.aboutProject.competenceCentersDescription' | transloco"></p>
                </li>
                <li>
                    <img ngSrc="/assets/images/kpo/ck.svg" alt="" height="84" width="84" />
                    <p class="title">{{ "dtmMainPageLib.subpage.kpo.aboutProject.trainingAndTestingCentersTitle" | transloco }}</p>
                    <p [innerHtml]="'dtmMainPageLib.subpage.kpo.aboutProject.trainingAndTestingCentersDescription' | transloco"></p>
                </li>
            </ul>
        </div>
        <dtm-main-page-lib-competency-center-info class="competence-center" [activeLanguage]="vm.activeLanguage" />

        <div class="grid funds">
            <h2 class="section-title">{{ "dtmMainPageLib.subpage.kpo.aboutProject.fundAllocation.title" | transloco }}</h2>
            <ul>
                <li>
                    <p class="title">{{ "dtmMainPageLib.subpage.kpo.aboutProject.fundAllocation.itLabel" | transloco }}</p>
                    <p>{{ "dtmMainPageLib.subpage.kpo.aboutProject.fundAllocation.itDescription" | transloco }}</p>
                </li>
                <li>
                    <p class="title">{{ "dtmMainPageLib.subpage.kpo.aboutProject.fundAllocation.infrastructureLabel" | transloco }}</p>
                    <p>{{ "dtmMainPageLib.subpage.kpo.aboutProject.fundAllocation.infrastructureDescription" | transloco }}</p>
                </li>
                <li>
                    <p class="title">{{ "dtmMainPageLib.subpage.kpo.aboutProject.fundAllocation.trainingCentersLabel" | transloco }}</p>
                    <p>{{ "dtmMainPageLib.subpage.kpo.aboutProject.fundAllocation.trainingCentersDescription" | transloco }}</p>
                </li>
            </ul>
        </div>
        <div class="grid beneficiaries">
            <h2>{{ "dtmMainPageLib.subpage.kpo.aboutProject.beneficiaries.title" | transloco }}</h2>
            <ul>
                <li>
                    <img ngSrc="assets/images/kpo/drone.svg" alt="" height="114" width="114" />
                    <div>
                        <p class="title">{{ "dtmMainPageLib.subpage.kpo.aboutProject.beneficiaries.dronePilotsLabel" | transloco }}</p>
                        <p>{{ "dtmMainPageLib.subpage.kpo.aboutProject.beneficiaries.dronePilotsDescription" | transloco }}</p>
                    </div>
                </li>
                <li>
                    <img ngSrc="assets/images/kpo/transport.svg" alt="" height="114" width="114" />
                    <div>
                        <p class="title">{{ "dtmMainPageLib.subpage.kpo.aboutProject.beneficiaries.localBusinessesLabel" | transloco }}</p>
                        <p>{{ "dtmMainPageLib.subpage.kpo.aboutProject.beneficiaries.localBusinessesDescription" | transloco }}</p>
                    </div>
                </li>
                <li>
                    <img ngSrc="assets/images/kpo/building.svg" alt="" height="114" width="114" />
                    <div>
                        <p class="title">{{ "dtmMainPageLib.subpage.kpo.aboutProject.beneficiaries.publicEntitiesLabel" | transloco }}</p>
                        <p>{{ "dtmMainPageLib.subpage.kpo.aboutProject.beneficiaries.publicEntitiesDescription" | transloco }}</p>
                    </div>
                </li>
                <li>
                    <img ngSrc="assets/images/kpo/park.svg" alt="" height="114" width="114" />
                    <div>
                        <p class="title">{{ "dtmMainPageLib.subpage.kpo.aboutProject.beneficiaries.residentsLabel" | transloco }}</p>
                        <p>{{ "dtmMainPageLib.subpage.kpo.aboutProject.beneficiaries.residentsDescription" | transloco }}</p>
                    </div>
                </li>
            </ul>
        </div>

        <dtm-main-page-lib-info
            [headerText]="'dtmMainPageLib.subpage.kpo.aboutProject.recruitmentBannerText' | transloco"
            [linkText]="'dtmMainPageLib.subpage.kpo.aboutProject.recruitmentBannerLinkText' | transloco"
            route="../competition"
        >
        </dtm-main-page-lib-info>

        <dtm-main-page-lib-schedule class="schedule" [activeLanguage]="vm.activeLanguage" />

        <dtm-main-page-lib-info
            [headerText]="'dtmMainPageLib.subpage.kpo.moreInfo.title' | transloco"
            [link]="BROCHURE_FILE"
            [linkText]="'dtmMainPageLib.subpage.kpo.moreInfo.brochureLinkText' | transloco"
            isDownload
        ></dtm-main-page-lib-info>

        <div class="grid">
            <div class="reporting-legal-violations">
                <img ngSrc="/assets/images/kpo/warning.svg" alt="" height="64" width="64" />
                <div>
                    <h2>{{ "dtmMainPageLib.subpage.kpo.aboutProject.reportingLegalViolations.title" | transloco }}</h2>
                    <p>{{ "dtmMainPageLib.subpage.kpo.aboutProject.reportingLegalViolations.descriptionText" | transloco }}</p>
                    <ol>
                        <li>
                            {{ "dtmMainPageLib.subpage.kpo.aboutProject.reportingLegalViolations.reportTool1Text" | transloco }}
                            <a [href]="REPORTING_VIOLATIONS_VIA_PANSA_URL" class="link" rel="noopener noreferrer" target="_blank">
                                {{ REPORTING_VIOLATIONS_VIA_PANSA_URL }}
                            </a>
                        </li>
                        <li>
                            {{ "dtmMainPageLib.subpage.kpo.aboutProject.reportingLegalViolations.reportTool2Text" | transloco }}
                            <a [href]="REPORTING_VIOLATIONS_VIA_CEUPT_URL" class="link" rel="noopener noreferrer" target="_blank">
                                {{ REPORTING_VIOLATIONS_VIA_CEUPT_URL }}
                            </a>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</ng-container>
